import React from "react";
import Settings from "containers/Template/Header/Desktop/Settings";
import Logo from "site_media/images/Logo_Cappy_Freefalling.png";
import Toolbar from "containers/Template/Header/Desktop/Toolbar";
import "containers/Template/Header/Header.css";
import ProfilePic from "containers/Template/Header/ProfilePic";
import Notifications from "./Desktop/Notifications";
import AxiosConfig from "axiosConfig";
import Mobile_toolbar from "./Mobile/Mobile_toolbar";
import MobileProfiles from "./Mobile/MobileProfiles";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.userList = JSON.parse(sessionStorage.getItem("userList"));
    this.userEmail = sessionStorage.getItem("userEmail");
    this.state = {
      email: "",
      fullName: "",
      userList: JSON.parse(sessionStorage.getItem("userList")),
      userEmail: sessionStorage.getItem("userEmail"),
      otherUsers: "",
      is_above_eighteen: false,
      isMenuOpen: false,
      showUsers: false,
    };

    for (let i in this.userList) {
      if (this.userList[i].email === this.userEmail) {
        this.state["email"] = this.userList[i].email;
        this.state["fullName"] = this.userList[i].full_name;
        this.state["is_above_eighteen"] = this.userList[i].is_above_eighteen;
      } else {
        this.state["otherUsers"] = [...this.state.otherUsers, this.userList[i]];
      }
    }
  }
  componentDidMount() {
    this.fetchProfileInfo(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const This = this;
    if (!prevState.userList || !prevState.otherUsers) {
      AxiosConfig.get("profile/parent-child-details/")
      .then(function (res) {
        const userList = res.data.user_list;
        const otherUsers=userList?.filter((item)=>item.email!==This.state.userEmail)
        This.setState({ userList: userList, otherUsers: otherUsers, })
        sessionStorage.setItem("userList", JSON.stringify(userList));
        }).catch(err=>console.error(err))
    }
  }
  fetchProfileInfo(obj) {
    AxiosConfig.get('profile/details/')
      .then(function (response) {
        obj.setProfileInfo(response);
      })
      .catch(function (error) {
      });
  }
  setProfileInfo(response) {
    let dob = response.data["dob"];
    let email = response.data["email"];
    let full_name = response.data["full_name"];
    let address = response.data["address"];
    let profile_pic = response.data["profile_pic"];
    let cover_pic = response.data["cover_pic"];
    let is_above_eighteen = response.data["is_above_eighteen"];

    this.setState((prevState) => ({
      email: email,
      userEmail: email,
      dob: dob,
      fullName: full_name,
      address: address,
      profile_pic: profile_pic,
      cover_pic: cover_pic,
      is_above_eighteen: is_above_eighteen
    }));
  }

  fetchUserDetails = () => {
    const obj = this;
    AxiosConfig.get("profile/parent-child-details/")
      .then(function (res) {
        const userList = res.data.user_list;
        let user_List = [];
        const loggedInUser = sessionStorage.getItem("loggedInUser");
        let userType = "";
        for (let i in userList) {
          user_List[i] = {
            email: userList[i].email,
            full_name: userList[i].full_name,
            is_above_eighteen: userList[i].is_above_eighteen,
            profile_pic: userList[i].profile_pic,
            user_type: userList[i].user_type,
          };
        }
        for (let k in user_List) {
          if (user_List[k].email === obj.userEmail) {
            userType = user_List[k].user_type;
          }
        }
        if (loggedInUser === obj.userEmail && userType === "child") {
          return;
        } else {
          sessionStorage.setItem("userList", JSON.stringify(user_List));
        }
      })
      .catch(function (error) {});
  };
  onUpdateUser(is_above_eighteen) {
    if (is_above_eighteen) {
      window.location.reload(false);
    } else {
      window.location.pathname = "/home";
    }
  }
  toggleMenu() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen,showUsers:false });
  }
  toggleShowUsers() {
    this.setState({ showUsers: !this.state.showUsers,isMenuOpen:false });
  }
  render() {
    return (
      <header className="header_head">
        <div
          className="header__mobile-child-select"
          onClick={this.toggleShowUsers.bind(this)}
        >
          <div className="child-select__item">
            <ProfilePic />
          </div>
        </div>
        <MobileProfiles
          isAboveEighteen={this.state["is_above_eighteen"]}
          otherUsers={this.state["otherUsers"]}
          onUpdateUser={this.onUpdateUser.bind(this)}
          showUsers={this.state.showUsers}
          toggleShowUsers={this.toggleShowUsers.bind(this)}
        />
        <div className="header__logo main mobile_logo">
          <a href="/home">
            <img src={Logo} className="header_main_logo" alt="Katamundi Logo" />
          </a>
        </div>

        <div className="header__toolbar">
          <div className="header__child-select">
            <div className="child-select__item--main">
              <div className="child-select__item">
                <ProfilePic />
                <div className="child-select__info">
                  <div className="child-select__name">
                    {this.state.fullName}
                    <span className="dropdown-icon" />
                  </div>
                </div>
              </div>
            </div>

            <div className="child-select__dropdown-menu">
              <Toolbar
                onUpdateUser={this.onUpdateUser.bind(this)}
                userList={this.state["userList"]}
                userEmail={this.state["userEmail"]}
                otherUsers={this.state["otherUsers"]}
                is_above_eighteen={this.state["is_above_eighteen"]}
              />
            </div>
          </div>
          <Notifications notificationCount={2} />
          <Settings />
        </div>
        <div className="header__mobile-toolbar-navlink">
          <div className="header__mobile-toolbar">
            <FontAwesomeIcon
              icon={faBars}
              color="#A2C4C6"
              size="lg"
              onClick={this.toggleMenu.bind(this)}
            />
          </div>
          <Mobile_toolbar
            isMenuOpen={this.state.isMenuOpen}
            toggleMenu={this.toggleMenu.bind(this)}
            isAboveEighteen={this.state["is_above_eighteen"]}
            otherUsers={this.state["otherUsers"]}
            onUpdateUser={this.onUpdateUser.bind(this)}
          />
        </div>
      </header>
    );
  }
}

export default Header;
